import React, { useState, useEffect, useContext } from 'react';
import requests from '../helpers/makeRequests';
import { CardComponent } from './CardComponent';
import CircularIndeterminate from './Spinner';
import { TitleSection } from './TitleSection';
import { UserContext } from './UserContext'

export const Categories = () => {

    const userContext = useContext(UserContext);
    const [albumsList, setAlbumsList] = useState([]);

    useEffect(() => {
        const getAlbums = async () => {
            const response = await requests.getCategories(userContext)
            setAlbumsList(response.categories.items)
        };
        getAlbums();
    }, [userContext])

    return (
        <div className="albums-section animate__fadeIn">
            <TitleSection title="Browse" />
            <div className="grid-albums">
                {Object.keys(albumsList).length === 0 ?
                    <CircularIndeterminate/> :
                    albumsList.map((album, index) => {
                        return (
                            <CardComponent key={index} title={album.name} image={album.icons[0].url} />
                        )
                    })
                }
            </div>
        </div>
    )
}
